import axios from 'axios';
import { ref } from 'vue';
import useBackendRouting from '@/composables/useBackendRouting';
import { useNotificationsStore } from '@/stores/notifications';

export default function useNotifications() {

  const store = useNotificationsStore();

  const { unlocalizedRoute } = useBackendRouting();

  const paginatedNotifications = ref([]);
  const fetchedNotifications = ref([]);
  const loadingNotifications = ref(false);
  const hasMoreNotifications = ref(true);
  const hasNoNotifications = ref(false);

  const metaData = ref(null);

  /**
   * Fetch notifications.
   */
  async function fetchNotifications() {

    let url = null;

    if (!metaData.value) {
      url = unlocalizedRoute('notifications.index');
    } else if (metaData.value.current_page < metaData.value.last_page) {
      url = unlocalizedRoute('notifications.index', { page: metaData.value.current_page + 1 });
    }

    if (url) {
      loadingNotifications.value = true;

      const { data: { data, meta } } = await axios.get(url);

      metaData.value = meta;

      fetchedNotifications.value = data.map(notification => ({
        id: notification.id,
        data: notification.data,
        read_at: notification.read_at,
        created_at_diff_humans: notification.created_at_diff_humans,
      }));

      paginatedNotifications.value = [...paginatedNotifications.value, ...fetchedNotifications.value];

      loadingNotifications.value = false;

      await markAsRead();

    } else {
      hasMoreNotifications.value = !(metaData.value.last_page > 1);
    }

    hasNoNotifications.value = paginatedNotifications.value.length === 0;
  }

  function markAsRead() {
    setTimeout(async function() {
      const unread = fetchedNotifications.value.filter(notification => notification.read_at === null).map(notification => notification.id);

      if (unread.length > 0) {
        await axios.post(unlocalizedRoute('notifications.mark_as_read'), { notifications: unread });

        store.decrementUnreadNotification(unread.length);
      }

      fetchedNotifications.value = [];
    },
    5000
    );
  }

  return {
    paginatedNotifications,
    fetchNotifications,
    loadingNotifications,
    hasMoreNotifications,
    hasNoNotifications,
  };
}
